var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { "justify-end": "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-col",
                { staticClass: "pr-0" },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { color: "white" },
                      attrs: {
                        "data-test": "aggiungi-variazione",
                        color: "green lighten-2",
                      },
                      on: { click: _vm.openDialog },
                    },
                    [
                      _vm._v(" Nuova Riga "),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("mdi-plus"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c(
                "v-col",
                { staticClass: "pr-0", attrs: { align: "right" } },
                [
                  _vm.distinta.draft && !_vm.contieneVariazioniDaInviare
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: { click: _vm.consolidaDistinta },
                        },
                        [
                          _vm._v(" Consolida Variazioni Validate "),
                          _c("v-icon", { attrs: { right: "" } }, [
                            _vm._v("mdi-check-all"),
                          ]),
                        ],
                        1
                      )
                    : _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            disabled: !_vm.contieneVariazioniDaInviare,
                          },
                          on: { click: _vm.inviaVariazioniConfermate },
                        },
                        [
                          _vm._v(" Conferma Operazioni "),
                          _c("v-icon", { attrs: { right: "" } }, [
                            _vm._v("mdi-check"),
                          ]),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-card-title", [_vm._v("Variazioni comunicate")]),
      _c(
        "v-expansion-panels",
        {
          attrs: { focusable: "" },
          model: {
            value: _vm.pannelliVariazioniAperti,
            callback: function ($$v) {
              _vm.pannelliVariazioniAperti = $$v
            },
            expression: "pannelliVariazioniAperti",
          },
        },
        [
          _vm._l(_vm.righeConVariazioni, function (row, i) {
            return [
              !row.eliminataDaAs400
                ? _c("RigaDistintaInValidazione", {
                    key: i,
                    attrs: {
                      "riga-distinta": row,
                      variazione: _vm.dict[row.id],
                    },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm.righeConVariazioni.length == 0 || _vm.righeConVariazioniTutteEliminate
        ? _c("v-alert", { attrs: { text: "", color: "info" } }, [
            _vm._v(" Nessuna riga con variazioni comunicata "),
          ])
        : _vm._e(),
      _c("v-card-title", [_vm._v("Altre righe")]),
      _c(
        "v-expansion-panels",
        {
          attrs: { focusable: "" },
          model: {
            value: _vm.pannelliAltreRigheAperti,
            callback: function ($$v) {
              _vm.pannelliAltreRigheAperti = $$v
            },
            expression: "pannelliAltreRigheAperti",
          },
        },
        _vm._l(_vm.altreRighe, function (row, i) {
          return _c(
            "v-expansion-panel",
            { key: i },
            [
              _c(
                "v-expansion-panel-header",
                { staticClass: "accordion-header" },
                [
                  _c(
                    "v-row",
                    {
                      staticStyle: { "background-color": "#f2f2f2" },
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "col-indice",
                          attrs: { "align-self": "center" },
                        },
                        [
                          _c("p", { staticClass: "text-center" }, [
                            _vm._v(" " + _vm._s(row.indiceRiga) + " "),
                          ]),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          class: {
                            "deleted-header-field": _vm.isDeleted(row),
                            "col-dati": !_vm.isDeleted(row),
                            "deleted-from-as400": row.eliminataDaAs400,
                          },
                        },
                        [
                          row.eliminataDaAs400
                            ? _c("em", [_vm._v("ELIMINATA DA AS400 - ")])
                            : _vm._e(),
                          _vm._v(" Componente: "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(row.innerRigaDistinta.componente) +
                                " (" +
                                _vm._s(row.innerRigaDistinta.idComponenteBga) +
                                ")"
                            ),
                          ]),
                          _vm._v(
                            " - " +
                              _vm._s(row.innerRigaDistinta.coloreComponente) +
                              " (" +
                              _vm._s(
                                row.innerRigaDistinta.idColoreComponenteBgf
                              ) +
                              ") - um: "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(row.innerRigaDistinta.unMisuraDiBa)),
                          ]),
                          _vm._v(", id: "),
                          _c("em", [
                            _vm._v(_vm._s(row.innerRigaDistinta.idBgj)),
                          ]),
                          _vm._v(" - Utilizzo: "),
                          _c("strong", [
                            _vm._v(_vm._s(row.innerRigaDistinta.utilizzo)),
                          ]),
                          row.inAttesaDiSincronizzazione
                            ? _c(
                                "div",
                                { staticStyle: { float: "right" } },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        size: "medium",
                                        color: "primary",
                                      },
                                    },
                                    [_vm._v("mdi-cloud-sync")]
                                  ),
                                ],
                                1
                              )
                            : row.conVariazioniConsolidate
                            ? _c(
                                "div",
                                { staticStyle: { float: "right" } },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { size: "medium", color: "green" },
                                    },
                                    [_vm._v("mdi-cloud-check")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-expansion-panel-content",
                {
                  class: {
                    "deleted-field": _vm.isDeleted(row),
                    "deleted-from-as400": row.eliminataDaAs400,
                  },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("div", { staticStyle: { "margin-top": "10px" } }, [
                            _vm._v(_vm._s(row.innerRigaDistinta.descri)),
                          ]),
                          _c(
                            "div",
                            { staticClass: "row-container" },
                            [
                              _c(
                                "ul",
                                _vm._l(
                                  row.quantitaPerTaglia,
                                  function (qta, index) {
                                    return _c("li", { key: "li_" + index }, [
                                      _c("div", { staticClass: "gray" }, [
                                        _vm._v(_vm._s(qta.desc)),
                                      ]),
                                      _vm._v(
                                        _vm._s(
                                          (+qta.qta)
                                            .toFixed(2)
                                            .replace(".", ",")
                                        ) + " "
                                      ),
                                    ])
                                  }
                                ),
                                0
                              ),
                              !row.eliminataDaAs400
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "row-button",
                                      attrs: {
                                        color: "primary",
                                        fab: "",
                                        "x-small": "",
                                        absolute: "",
                                        disabled: !_vm.canEditRiga(row),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editRiga(row)
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("mdi-pencil")])],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          row.variazioniComunicate &&
                          row.variazioniComunicate.length > 0
                            ? _c("RigaDistintaListaVariazioni", {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { "riga-distinta": row },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      !(row.inAttesaDiSincronizzazione || row.eliminataDaAs400)
                        ? _c(
                            "v-col",
                            {
                              staticClass: "side-btn-field",
                              attrs: { sm: "2", md: "1" },
                            },
                            [
                              _c(
                                "v-container",
                                { attrs: { "fill-height": "", fluid: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        row: "",
                                        wrap: "",
                                        "align-center": "",
                                        "justify-center": "",
                                      },
                                    },
                                    [
                                      _vm.isDeleted(row)
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                fab: "",
                                                dark: "",
                                                small: "",
                                                color: "orange",
                                                "data-test": "undo-variazione",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.undoEliminazioneRiga(
                                                    row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [_vm._v("mdi-undo")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                fab: "",
                                                dark: "",
                                                small: "",
                                                color: "red",
                                                "data-test":
                                                  "elimina-variazione",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.eliminaRiga(row)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [_vm._v("mdi-delete")]
                                              ),
                                            ],
                                            1
                                          ),
                                      _vm.mostraCorrelate(row)
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticStyle: { margin: "10px" },
                                              attrs: {
                                                fab: "",
                                                dark: "",
                                                small: "",
                                                color:
                                                  _vm.contieneValidazioniCorrelate(
                                                    row
                                                  )
                                                    ? "purple"
                                                    : "blue",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  row.mostraCorrelate =
                                                    !row.mostraCorrelate
                                                },
                                              },
                                            },
                                            [
                                              row.mostraCorrelate
                                                ? _c(
                                                    "v-icon",
                                                    { attrs: { dark: "" } },
                                                    [
                                                      _vm._v(
                                                        "mdi-layers-triple-outline"
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "v-icon",
                                                    { attrs: { dark: "" } },
                                                    [
                                                      _vm._v(
                                                        "mdi-layers-triple"
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  row.mostraCorrelate
                    ? _c(
                        "v-row",
                        { staticStyle: { width: "100%" } },
                        [
                          _vm.mostraCorrelate(row)
                            ? _c("ValidazioniMassive", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "riga-distinta": row,
                                  variazione: _vm.dict[row.id],
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "v-expansion-panels",
        {
          attrs: { focusable: "" },
          model: {
            value: _vm.pannelliAltreRigheAperti,
            callback: function ($$v) {
              _vm.pannelliAltreRigheAperti = $$v
            },
            expression: "pannelliAltreRigheAperti",
          },
        },
        _vm._l(_vm.nuoveRighe, function (row, i) {
          return _c(
            "v-expansion-panel",
            { key: i },
            [
              _c(
                "v-expansion-panel-header",
                { staticClass: "accordion-header" },
                [
                  _c(
                    "v-row",
                    {
                      staticStyle: { "background-color": "#f2f2f2" },
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "col-indice",
                          attrs: { "align-self": "center" },
                        },
                        [
                          _c("p", { staticClass: "text-center" }, [
                            _vm._v(
                              " " + _vm._s(row.rigaDistinta.indiceRiga) + " "
                            ),
                          ]),
                        ]
                      ),
                      _c("v-col", { staticClass: "col-dati modified-field" }, [
                        _c("strong", [_vm._v("NUOVA RIGA")]),
                        _vm._v(" - Componente: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              row.rigaDistinta.innerRigaDistinta.idComponenteBga
                            ) + " "
                          ),
                        ]),
                        _vm._v(
                          " - " +
                            _vm._s(
                              row.rigaDistinta.innerRigaDistinta
                                .idColoreComponenteBgf
                            ) +
                            " - um: "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              row.rigaDistinta.innerRigaDistinta.unMisuraDiBa
                            )
                          ),
                        ]),
                        _vm._v(" - Utilizzo: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(row.rigaDistinta.innerRigaDistinta.utilizzo)
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-expansion-panel-content",
                { staticClass: "modified-field" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("div", { staticStyle: { "margin-top": "10px" } }, [
                            _c(
                              "ul",
                              _vm._l(
                                row.variazioneRigaDistintaQtaTaglia,
                                function (qta, index) {
                                  return _c("li", { key: "li_" + index }, [
                                    _c("div", { staticClass: "gray" }, [
                                      _vm._v(_vm._s(qta.desc)),
                                    ]),
                                    _vm._v(
                                      _vm._s(
                                        (+qta.qtaModificata)
                                          .toFixed(2)
                                          .replace(".", ",")
                                      ) + " "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]),
                          row.variazioniComunicate &&
                          row.variazioniComunicate.length > 0
                            ? _c("RigaDistintaListaVariazioni", {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { "riga-distinta": row },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "modified-field side-btn-field",
                          attrs: { sm: "2", md: "2" },
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "fill-height": "", fluid: "" } },
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    column: "",
                                    wrap: "",
                                    "align-center": "",
                                    "justify-center": "",
                                  },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: "red",
                                        "data-test": "elimina-variazione",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.eliminaNuovaRiga(row)
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { dark: "" } }, [
                                        _vm._v("mdi-delete"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: _vm.contieneModificheCorrelate(
                                          row
                                        )
                                          ? "purple"
                                          : "blue",
                                      },
                                      on: {
                                        click: function ($event) {
                                          row.mostraCorrelate =
                                            !row.mostraCorrelate
                                        },
                                      },
                                    },
                                    [
                                      row.mostraCorrelate
                                        ? _c(
                                            "v-icon",
                                            { attrs: { dark: "" } },
                                            [
                                              _vm._v(
                                                "mdi-layers-triple-outline"
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "v-icon",
                                            { attrs: { dark: "" } },
                                            [_vm._v("mdi-layers-triple")]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  row.mostraCorrelate
                    ? _c(
                        "v-row",
                        { staticStyle: { width: "100%" } },
                        [
                          _c("VariazioniMassive", {
                            staticStyle: { width: "100%" },
                            attrs: { "variazione-riferimento": row },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _vm.altreRighe.length == 0
        ? _c("v-alert", { attrs: { text: "", color: "info" } }, [
            _vm._v(" Nessuna riga senza variazioni comunicata "),
          ])
        : _vm._e(),
      _c("DialogNewVariazione", {
        ref: "dialog",
        attrs: { idDistinta: _vm.distinta.id },
        on: { "variazione-creata": _vm.onRigaCreata },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }